import { type INode } from '@/lib/ris-types'
import Image from 'next/image'
import Link from 'next/link'
import RefLink from './RefLink'

export default function Inline ({ value, children, type, skipInitialGldsym = false, skipInitialSymbol = false, richRefLinks = true, ...props }: INode & { skipInitialGldsym?: boolean, skipInitialSymbol?: boolean, richRefLinks?: boolean }) {
  if (type === 'link') {
    if (props.href) { // Some RIS documents have actual links in them as type "link". If so, render them as normal links
      return (
        <Link href={props.href}>
          {' '}{value}
        </Link>
      )
    }
    
    const ref = props.refs?.[0]
    if (!ref.value) return null

    return (
      <RefLink refLink={ref} hover={richRefLinks} />
    )
  }

  if (typeof value === 'string') {
    // Use a template literal here as to prevent empty comments being added to the HTML, in order to reduce payload size (https://github.com/facebook/react/issues/14725)
    return ` ${value}`
  }
  if (type === 'binary') {
    return (
      <Image
        src={`https://www.ris.bka.gv.at${children?.[0]?.value as string}`}
        width={Number(props.width)}
        height={Number(props.height)}
        alt={props.alt ?? ''}
      />
    )
  }

  if (children?.length === 1 && children[0].value) {
    // Optimization to prevent additional mapping
    return ` ${children[0].value}`
  }

  return children?.map((item, index) => {
    if (index === 0 && skipInitialGldsym && item.type === 'gldsym') return null
    if (index === 0 && skipInitialSymbol && item.type === 'symbol') return null
    if (typeof item === 'string') return item

    return (
      <Inline key={index} {...item} richRefLinks={richRefLinks} />
    )
  }) ?? []
}
